import _ from 'lodash';
import { decryptURL } from './DecryptionService';
import { contentType } from '../constants/constants';

import { Prompt } from '../interface/Prompt';

export const frameTestQuestions = async (data: any, isMiniVersion: string = 'false', product: string = '') => {
    let questionList: Prompt[] = [];
    let partIdx: Record<number, string> = {};
    let hardQuestionList: Prompt[] = [];
    let mediumQuestionList: Prompt[] = [];

    if (isMiniVersion === 'true') {
        questionList = frameQuestionsForMiniVersion(data);
        partIdx = { 0: 'part1' };
    } else {
        let part1QuestionList: any = frameQuestionsForPart1(data?.content?.partOne);
        if (part1QuestionList?.length > 0) {
            questionList = [...part1QuestionList];
            partIdx = { 0: 'part1' };
        }
        let part2QuestionList: any = product !== "HOELT" 
        ? frameQuestionsForPart2(data.extendedContent?.partTwo ?? data.content.partTwo) : 
        frameQuestionsForHoeltPart2(data?.extendedContent?.partTwo);
        if (part2QuestionList?.length > 0) {
            questionList = [...questionList, ...part2QuestionList];
            partIdx[questionList.length - part2QuestionList?.length] = 'part2';
        }
        let returnedList: any = product !== "HOELT" ?
            frameQuestionsForPart3(data?.extendedContent?.partThree ?? data.content.partThree) :
            frameQuestionsForHoeltPart3(data?.extendedContent?.partThree);
        let part3QuestionList = returnedList[0];
        hardQuestionList = returnedList[1];
        mediumQuestionList = returnedList[2];
        if (part3QuestionList?.length > 0) {
            questionList = [...questionList, ...part3QuestionList];
            partIdx[questionList.length - part3QuestionList?.length] = 'part3';
        }
    }
    const nonUniqQuestionList = [...questionList, ...hardQuestionList, ...mediumQuestionList];
    const uniqQuestionList = _.uniqBy(nonUniqQuestionList, ({ localizedMedia }) => localizedMedia.audioPreSignUrl);

    for (const question of uniqQuestionList) {
        try {
            const encryptedAudioUrl = question?.localizedMedia.audioPreSignUrl;
            question.contentType = contentType.prompt;

            question.localizedMedia.audioPreSignUrl = await decryptURL(encryptedAudioUrl);
            if (question?.variants?.length) {
                for (const variants of question.variants) {
                    variants.localizedMedia.audioPreSignUrl = await decryptURL(
                        variants?.localizedMedia.audioPreSignUrl,
                    );
                    variants.localizedMedia.contentType = contentType.variant;
                }
            }
        } catch (error) {
            console.error('Error decrypting Content URL:', error);
        }
    }

    return { questionList, partIdx, hardQuestionList, mediumQuestionList };
};

// frame question for part 1
const frameQuestionsForPart1 = (partData: any) => {
    let questionList: Prompt[] = [];
    if (partData?.introFrame?.introStatement) {
        questionList?.push({
            ...partData?.introFrame?.introStatement,
            noIntentDetection: false,
            partName: partData.partName,
            partId: partData.partId,
            frame: 'IntroFrame',
        });
    }
    if (partData?.introFrame?.prompts) {
        partData?.introFrame?.prompts?.sort((a: any, b: any) => (a.sequence < b.sequence ? -1 : 1));
        questionList = partData?.introFrame?.prompts
            ? [
                  ...questionList,
                  ...partData.introFrame.prompts.map((prompt: any) => ({
                      ...prompt,
                      noIntentDetection: false,
                      partName: partData.partName,
                      partId: partData.partId,
                      frame: 'IntroFrame',
                  })),
              ]
            : questionList;
    }
    if (partData?.introFrame?.outroStatement) {
        questionList?.push({
            ...partData?.introFrame?.outroStatement,
            partName: partData.partName,
            partId: partData.partId,
            frame: 'IntroFrame',
        });
    }
    if (partData?.frameA?.prompts) {
        partData?.frameA?.prompts?.sort((a: any, b: any) => (a.sequence < b.sequence ? -1 : 1));
        questionList = partData?.frameA?.prompts
            ? [
                  ...questionList,
                  ...partData.frameA.prompts.map((prompt: any) => ({
                      ...prompt,
                      noIntentDetection: false,
                      partName: partData.partName,
                      partId: partData.partId,
                      frame: 'frameA',
                  })),
              ]
            : questionList;
    }
    if (partData?.frameBCOne?.prompts) {
        partData?.frameBCOne?.prompts?.sort((a: any, b: any) => (a.sequence < b.sequence ? -1 : 1));
        questionList = partData?.frameBCOne?.prompts
            ? [
                  ...questionList,
                  ...partData.frameBCOne.prompts.map((prompt: any) => ({
                      ...prompt,
                      partName: partData.partName,
                      partId: partData.partId,
                      frame: 'frameBCOne',
                  })),
              ]
            : questionList;
    }
    if (partData?.frameBCTwo?.prompts) {
        partData?.frameBCTwo?.prompts?.sort((a: any, b: any) => (a.sequence < b.sequence ? -1 : 1));
        questionList = partData?.frameBCTwo?.prompts
            ? [
                  ...questionList,
                  ...partData.frameBCTwo.prompts.map((prompt: any) => ({
                      ...prompt,
                      partName: partData.partName,
                      partId: partData.partId,
                      frame: 'frameBCTwo',
                  })),
              ]
            : questionList;
    }
    return questionList;
};

// frame question for part 2
const frameQuestionsForPart2 = (partData: any) => {
    let questionList: Prompt[] = [];
    if (partData?.introStatement) {
        questionList?.push({
            ...partData?.introStatement,
            partName: partData.partName,
            partId: partData.partId,
            frame: 'part2Intro',
        });
    }
    if (partData?.frameD?.cardStatement) {
        questionList?.push({
            ...partData?.frameD?.cardStatement,
            showTimer: true,
            partName: partData.partName,
            partId: partData.partId,
            frame: "frameD",
        });
    }
    if (partData?.frameD?.bridgeStatement) {
        questionList?.push({
            ...partData?.frameD?.bridgeStatement,
            partName: partData.partName,
            partId: partData.partId,
            frame: "frameD",
        });
    }
    if (partData?.frameD?.prompts) {
        partData?.frameD?.prompts?.sort((a: any, b: any) => (a.sequence < b.sequence ? -1 : 1));
        partData.frameD.prompts[0] = {
            ...partData.frameD.prompts[0],
            monologueQuestion: true,
            partName: partData.partName,
            partId: partData.partId,
            frame: "frameD",
        };
        questionList = partData?.frameD?.prompts
            ? [
                  ...questionList,
                  ...partData.frameD.prompts.map((prompt: any) => ({
                      ...prompt,
                      partName: partData.partName,
                      partId: partData.partId,
                      frame: "frameD",
                  })),
              ]
            : questionList;
    }
 
    return questionList;
};

// frame question for part 3
const frameQuestionsForPart3 = (partData: any) => {
    let questionList: Prompt[] = [];
    let hardQuestionList: Prompt[] = [];
    let mediumQuestionList: Prompt[] = [];
    if (partData?.introStatement) {
        questionList?.push({
            ...partData?.introStatement,
            partName: partData.partName,
            partId: partData.partId,
            frame: 'part3Intro',
        });
    }
    if (partData?.frameE?.prompts) {
        partData?.frameE?.prompts?.sort((a: any, b: any) => (a.sequence < b.sequence ? -1 : 1));
        questionList = partData?.frameE?.prompts
            ? [
                  ...questionList,
                  ...partData.frameE.prompts.map((prompt: any) => ({
                      ...prompt,
                      partName: partData.partName,
                      partId: partData.partId,
                      frame: "frameE",
                  })),
              ]
            : questionList;
    }
    if (partData?.frameF?.prompts) {
        partData?.frameF?.prompts?.sort((a: any, b: any) => (a.sequence < b.sequence ? -1 : 1));
        mediumQuestionList = partData?.frameF?.prompts
            ? [
                  ...partData.frameF.prompts.map((prompt: any) => ({
                      ...prompt,
                      partName: partData.partName,
                      partId: partData.partId,
                      frame: 'frameF',
                  })),
              ]
            : mediumQuestionList;
        mediumQuestionList.push({
            ...partData?.outroStatement,
            partName: partData.partName,
            partId: partData.partId,
            frame: 'frameF',
        });
    }
    if (partData?.frameG?.prompts) {
        partData?.frameG?.prompts?.sort((a: any, b: any) => (a.sequence < b.sequence ? -1 : 1));
        hardQuestionList = partData?.frameG?.prompts
            ? [
                  ...partData.frameG.prompts.map((prompt: any) => ({
                      ...prompt,
                      partName: partData.partName,
                      partId: partData.partId,
                      frame: 'frameG',
                  })),
              ]
            : hardQuestionList;
        hardQuestionList.push({
            ...partData?.outroStatement,
            partName: partData.partName,
            partId: partData.partId,
            frame: 'frameG',
        });
    }
    return [questionList, hardQuestionList, mediumQuestionList];
};

const frameQuestionsForMiniVersion = (contentData: any) => {
    let questionList: Prompt[] = [];
    let partData = contentData?.content?.partOne;
    if (partData?.introFrame?.introStatement) {
        questionList?.push({ ...partData?.introFrame?.introStatement, noIntentDetection: true });
    }
    if (partData?.introFrame?.prompts) {
        partData?.introFrame?.prompts?.sort((a: any, b: any) => (a.sequence < b.sequence ? -1 : 1));
        questionList = partData?.introFrame?.prompts
            ? [
                  ...questionList,
                  ...partData.introFrame.prompts.map((prompt: any) => ({
                      ...prompt,
                      noIntentDetection: true,
                      frame: 'IntroFrame',
                      partName: partData.partName,
                      partId: partData.partId,
                  })),
              ]
            : questionList;
    }
    if (partData?.introFrame?.outroStatement) {
        questionList?.push({
            ...partData?.introFrame?.outroStatement,
            frame: 'IntroFrame',
            partName: partData.partName,
            partId: partData.partId,
        });
    }
    if (partData?.frameA?.prompts) {
        partData?.frameA?.prompts?.sort((a: any, b: any) => (a.sequence < b.sequence ? -1 : 1));
        questionList = partData?.frameA?.prompts
            ? [
                  ...questionList,
                  ...partData.frameA.prompts.map((prompt: any) => ({
                      ...prompt,
                      noIntentDetection: false,
                      frame: 'frameA',
                      partName: partData.partName,
                      partId: partData.partId,
                  })),
              ]
            : questionList;
    }
    if (partData?.frameBCOne?.prompts) {
        partData?.frameBCOne?.prompts?.sort((a: any, b: any) => (a.sequence < b.sequence ? -1 : 1));
        questionList = partData?.frameBCOne?.prompts
            ? [
                  ...questionList,
                  ...partData.frameBCOne.prompts.map((prompt: any) => ({
                      ...prompt,
                      frame: 'frameBCOne',
                      partName: partData.partName,
                      partId: partData.partId,
                  })),
              ]
            : questionList;
    }
    if (partData?.frameBCTwo?.prompts) {
        partData?.frameBCTwo?.prompts?.sort((a: any, b: any) => (a.sequence < b.sequence ? -1 : 1));
        questionList = partData?.frameBCTwo?.prompts
            ? [
                  ...questionList,
                  ...partData.frameBCTwo.prompts.map((prompt: any) => ({
                      ...prompt,
                      frame: 'frameBCTwo',
                      partName: partData.partName,
                      partId: partData.partId,
                  })),
              ]
            : questionList;
    }
    return questionList;
};


const frameQuestionsForHoeltPart2 = (partData: any) => {
    let questionList: Prompt[] = [];
    if( partData?.introStatement) { 
        questionList.push({
            ...partData?.introStatement,
            partName: partData.partName,
            partId: partData.partId,
            frame: 'part2Intro',
            type: 'rubric'
        })
    }
    if( partData?.genericBridgeStatement ) {
        questionList.push({
            ...partData?.genericBridgeStatement?.find((item:any) => item.localizedMedia.audioRef.includes('st1')),
            partName: partData.partName,
            partId: partData.partId,   
            frame: 'frameDorE',
            type: 'listen',
            audioBarPause: true,
            frameType: partData?.frameDorE?.frameType
        })
    }
    if( partData?.frameDorE?.voiceMailStatement ) {
        questionList.push({
            ...partData?.frameDorE?.voiceMailStatement,
            partName: partData.partName,
            partId: partData.partId,   
            frame: "frameDorE",
            type: 'listen',
            showPrepCard: true,
            expectedMaxDuration: 0,
            playAudioTwice: true,
            frameType: partData?.frameDorE?.frameType
        })
    }
    questionList.push({
        ...partData?.genericBridgeStatement?.find((item:any) => item.localizedMedia.audioRef.includes('st2')),
        partName: partData.partName,
        partId: partData.partId,   
        frame: 'frameDorE',
        type: 'prepare',
        showTimer: true,
        expectedMaxDuration: 45,
        transcript: true,
        frameType: partData?.frameDorE?.frameType
    }, 
    {
        ...partData?.genericBridgeStatement?.find((item:any) => item.localizedMedia.audioRef.includes('st3')),
        partName: partData.partName,
        partId: partData.partId,   
        frame: 'frameDorE',
        type: 'speak',
        frameType: partData?.frameDorE?.frameType
    }
    )
    if (partData?.frameDorE?.introPartTwoGenericPromptResponse) {
        questionList.push({
            ...partData.frameDorE?.introPartTwoGenericPromptResponse,
            monologueQuestion: true,
            partName: partData.partName,
            partId: partData.partId,
            frame: "frameDorE",
            frameType: partData?.frameDorE?.frameType
        },
        {
            ...partData.frameDorE?.promptResponses,
            partName: partData.partName,
            partId: partData.partId,
            frame: "frameDorE",
            frameType: partData?.frameDorE?.frameType
        })
    }

    return questionList;
}

const frameQuestionsForHoeltPart3 = (partData: any) => {
    let questionList: Prompt[] = [];
    let hardQuestionList: Prompt[] = [];
    let mediumQuestionList: Prompt[] = [];
    if (partData?.introStatement) {
        questionList?.push({
            ...partData?.introStatement,
            partName: partData.partName,
            partId: partData.partId,
            frame: 'part3Intro',
        });
    }
    if (partData?.introPrompt) {
        questionList?.push({
            ...partData?.introPrompt,
            partName: partData.partName,
            partId: partData.partId,
            frame: 'part3Intro',
        });
    }
    let availableFrames = ['frameF', 'frameG', 'frameH', 'frameI'];
    let lastAvailableFrame = '';
    for (const frame of availableFrames) {
        if (partData?.[frame]?.prompts) {
            lastAvailableFrame = frame;
            partData[frame].prompts.sort((a: any, b: any) => (a.sequence < b.sequence ? -1 : 1));
            questionList = [
                ...questionList,
                ...partData[frame].prompts.map((prompt: any) => ({
                    ...prompt,
                    partName: partData.partName,
                    partId: partData.partId,
                    frame,
                })),
            ];
        }
    }
    questionList.push({
        ...partData?.outroStatement,
        partName: partData.partName,
        partId: partData.partId,
        frame: lastAvailableFrame,
    });
    return [questionList, hardQuestionList, mediumQuestionList];
}